module.exports = __webpack_public_path__ + "img/integration.b85b8737.png";